<script setup lang="ts">
import { Store } from 'lucide-vue-next'

import type { AudienceStore } from '@/types/types'

const props = withDefaults(
  defineProps<{
    stores?: AudienceStore[]
    merchantStores?: AudienceStore[]
  }>(),
  {
    stores: () => [],
    merchantStores: () => []
  }
)

const { t } = useI18n()
const { stores: localMerchantStores } = useLocalStorage()

const MAX_STORES_SHOWN_IN_TOOLTIP = 5

const displayedStores = computed<Pick<AudienceStore, 'id' | 'name'>[]>(() => {
  if (props.stores.length > 0) return props.stores
  if (props.merchantStores.length > 0) return props.merchantStores
  return localMerchantStores.value
})
</script>

<template>
  <div class="flex items-center gap-1">
    <BaseChip v-if="displayedStores.length === 0" :text="t('global.multiselect.stores.allSelectedText')">
      <template #leading>
        <Store />
      </template>
    </BaseChip>
    <AppTooltip v-else>
      <template #tooltip-content>
        <div class="flex flex-col gap-2 px-1 text-left">
          <span
            v-for="store in displayedStores.slice(0, MAX_STORES_SHOWN_IN_TOOLTIP)"
            :key="store.id"
            class="text-md"
            >{{ store.name }}</span
          >
          <span v-if="displayedStores.length > MAX_STORES_SHOWN_IN_TOOLTIP">
            {{
              t('global.multiselect.stores.otherStores', {
                count: displayedStores.length - MAX_STORES_SHOWN_IN_TOOLTIP
              })
            }}
          </span>
        </div>
      </template>
      <BaseChip :text="t('global.multiselect.stores.storesCount', { count: displayedStores.length })">
        <template #leading>
          <Store />
        </template>
      </BaseChip>
    </AppTooltip>
  </div>
</template>
